import React, { useState, useEffect } from "react";
import { motion, AnimatePresence,  } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { meetingLink } from "../../data/navlink";


// const background = require("../../assests/Anil.jpeg")

const img1 = require("../../assests/anildhyanicrop.jpeg");
const img2 = require("../../assests/bg1.jpeg");
const img3 = require("../../assests/bg2.jpeg");

export default function HomeScreen() {
  const backgroundImage = [img1, img2, img3];
  const [currentIndex, setCurrentIndex] = useState(0);

  const navigate = useNavigate()

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === backgroundImage.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-screen overflow-hidden flex items-center justify-center font-sans">
      {/* Background Image Animation */}
      <AnimatePresence>
        <motion.div
          
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.1 }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage[currentIndex]})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      </AnimatePresence>

      {/* Overlay for Better Readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/90 via-[#1E293B]/70 to-transparent"></div>

      {/* Content Section */}
      <div className="relative z-10 text-center text-white px-6 max-w-3xl">
        {/* Badge/Certification Section */}
        <motion.div
          className="flex justify-center space-x-4 mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <span className="px-4 py-1 bg-gray-700/80 text-gray-300 font-semibold rounded-full text-sm uppercase tracking-wide">
            Trusted Since 1992
          </span>
          {/* <span className="px-4 py-1 bg-gray-700/80 text-gray-300 font-semibold rounded-full text-sm uppercase tracking-wide">
            Award-Winning Firm
          </span> */}
        </motion.div>

        {/* Main Headings */}
        <motion.h1
          className="text-5xl md:text-6xl font-bold text-goldenYellow leading-tight"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Anil Dhyani & Associates
        </motion.h1>

        {/* <motion.h2
          className="mt-3 text-2xl md:text-3xl font-semibold italic text-gray-300"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Justice. Integrity. Excellence.
        </motion.h2> */}

        {/* Subheading */}
        <motion.p
          className="mt-6 text-lg text-gray-300 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          With over 30 years of experience, we provide unparalleled legal solutions with integrity and precision. Let us guide you through the complexities of law with expertise and dedication.
        </motion.p>

        {/* Call to Action Button */}
        <motion.button
        onClick={() => window.location.href = `${meetingLink }`}
          className="mt-8 px-8 py-3 bg-transparent text-goldenYellow font-bold border-2 border-goldenYellow rounded-full shadow-md hover:bg-goldenYellow hover:text-[#0F172A] transition-all duration-300"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          Schedule a Consultation
        </motion.button>
      </div>
    </div>
  );
}